<app-splash-screen class="overflow-hidden"></app-splash-screen>
<div class="w-full flex flex-column flex-grow-1">
  <app-nav-header></app-nav-header>

  <router-outlet></router-outlet>

</div>
